import { Flex } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

interface LinkMessageProps {
	borrowerId: string;
}

export function LinkMessage({ borrowerId }: LinkMessageProps) {
	return (
		<Flex
			w="32px"
			h="32px"
			bg="white"
			border="1px solid #D4D4D4"
			borderRadius="100px"
			alignItems="center"
			justifyContent="center"
			as={Link}
			to={`/messages?user=${borrowerId}`}
			color="#6C6B6E"
			_hover={{
				color: "primary",
				borderColor: "primary",
			}}
		>
			<FontAwesomeIcon icon={["far", "message-lines"]} />
		</Flex>
	);
}
